module.exports = __webpack_public_path__ + "static/media/peterArt11.7ed10dcb.jpg";